import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import { getRUCEmpresaRecibidos, isClient } from "redux/actions/userActions";
//componentes del sistema
import TablePaginatedVoucher from "widgets/Tables/TablePaginatedVoucherAts"

import tableStyle from "configurations/styles/table"
import { useStylesGlobal } from "configurations/styles/theme";
import SearchVoucher from "views/facturacion/Forms/SearchVoucher";
import { CircularProgress, Grid, Button, Card, Avatar, Backdrop } from '@material-ui/core';
import XMLVoucherBtn from 'views/facturacion/Buttons/XMLVoucherBtn';
import TablePaginatedVoucherSearch from 'widgets/Tables/TablePaginatedVoucherSearchAts';
import TablePaginatedSearchVoucher from 'widgets/Tables/TablePaginatedSearchVoucherAts';
import PDFVoucherBtn from "views/facturacion/AuthorizedIssuedVouchers/Buttons/PDFVoucherBtn";

import { API_GET_VOUCHER_ATS, API_GET_SEARCH_AUTHORIZED } from './apis';
import { getZip } from "views/facturacion/Vouchers/validate";
import { useSnackbar } from 'notistack';
import EditSupportCode from './Add/EditSupportCode';
const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: '50px',
        flexGrow: 1,
        paddingLeft: '3%',
        paddingRight: '3%',
        marginBottom: '5%'
    },
    backdrop: {
        zIndex: "3000",
        color: "#fff",
    },
    margin: {
        marginBottom: '0.5%',
    },
    zip: {
        padding: "14px",
    },
    iconzip: {
        padding: "50px"
    },
}));


const VoucherReceivedAts = () => {

    const tokenUser = useSelector(state => state.user.tk);
    const classesView = useStyles();
    const classesGlobales = useStylesGlobal();
    const [paramSearch, setParamSearch] = useState('');
    //state para actualizar la vista
    const [update, setUpdate] = useState(1);
    const [openLoader, setOpenLoader] = useState(false);
    const [idComprobantes, setIdComprobantes] = useState([]);
    const { enqueueSnackbar } = useSnackbar();


    const columns = [
        { title: 'Número', field: `secuencial`, cellStyle: tableStyle.cellTable, width: '10%', render: rowData => `${rowData.establecimiento}-${rowData.puntoEmision}-${rowData.secuencial}` },
        { title: 'Fecha Emisión', field: 'fechaEmision', cellStyle: tableStyle.cellTable, width: '10%', render: rowData => rowData.fechaEmision.substring(0, 10) },
        //{ title: 'Fecha Autorización', field: 'comprobanteElectronico.fechaAutorizacion', cellStyle: tableStyle.cellTable, width: '15%',render: rowData => rowData?(rowData.comprobanteElectronico.fechaAutorizacion.substring(0, 10)).concat((new Date(rowData.comprobanteElectronico.fechaAutorizacion)).toString().substring(15, 24)):null},
        //{ title: 'Fecha Autorización', cellStyle: tableStyle.cellTable, width: '15%',render: rowData => 'hola'},
        { title: 'Emisor', field: 'razonSocial', cellStyle: tableStyle.cellLeft, width: '30%' },
        { title: 'Código sustento', field: 'codigoSustento', cellStyle: tableStyle.cellLeft, width: '30%' },
        { title: 'Tipo', field: 'tipoComprobante', cellStyle: tableStyle.cellTable, width: '12%' },
        { title: "Editar", cellStyle: tableStyle.cellTable, width: "3%", render: (rowData) => (<EditSupportCode voucher={rowData} updateView={reload} />), },
        // { title: 'PDF', cellStyle: tableStyle.cellTable, width: '5%', render: rowData => <PDFVoucherBtn voucher={rowData} /> },
        // { title: 'XML', cellStyle: tableStyle.cellTable, width: '5%', render: rowData => <XMLVoucherBtn voucher={rowData} /> },

    ];


    const requestConfig = {
        uri: API_GET_VOUCHER_ATS + (tokenUser ? getRUCEmpresaRecibidos(tokenUser) : "0"),
        metodo: 'get',
        body: null,
        page: 0,
        elementos: 15,
        sort: 'id,desc'
    }

    const requestConfigSeacrh = {
        uri: API_GET_VOUCHER_ATS + (tokenUser ? getRUCEmpresaRecibidos(tokenUser) : "0"),
        metodo: 'get',
        body: null,
        page: 0,
        elementos: 15,
        sort: 'id,desc',
    }
    const reload = () => {
        setUpdate(1);
    };

    useEffect(() => {

    }, [update])

    const generateZip = () => {
        if (typeof idComprobantes !== 'undefined' && Object.entries(idComprobantes).length !== 0) {
            getZip(setOpenLoader, idComprobantes)

            /* enqueueSnackbar(`No se pudo generar el zip`, {
                 variant: "warning",
                 anchorOrigin: {
                     vertical: "top",
                     horizontal: "right",
                 },
             });*/
        } else {
            enqueueSnackbar(`Seleccione al menos un comprobante`, {
                variant: "warning",
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
            });
        }
    }

    const setIdVoucher = (dataTable) => {
        let idList = dataTable.map(data => data.claveAcceso);
        setIdComprobantes(idList)
    }

    const headerBottons = () => {
        if (update === 6) {
            return (
                <Grid container direction="row" justify="flex-start" alignItems="center" >

                    <Grid item xs={2}>
                        <Button variant="contained" color="primary" onClick={() => setUpdate(2)}>
                            Mostrar Todos
                        </Button>
                    </Grid>
                </Grid>
            );
        }

    }


    const renderTable = () => {
        switch (update) {
            case 1:
                setUpdate(2);
                return (
                    <div align='center'>
                        <CircularProgress />
                    </div>
                );
            case 2:
                return (
                    <TablePaginatedVoucher
                        columns={columns}
                        title=""
                        numeroFilas={5}
                        requestConfig={requestConfig}
                        BotonesHeader={headerBottons}
                        seleccion={true}
                        setIdVoucher={setIdVoucher}
                    />
                );
            case 3:
                return (
                    <Fragment>
                        <TablePaginatedVoucherSearch
                            title=""
                            columns={columns}
                            numeroFilas={5}
                            requestConfig={requestConfigSeacrh}
                            BotonesHeader={headerBottons}
                            paramSearch={paramSearch}
                            seleccion={true}
                            setIdVoucher={setIdVoucher}
                        />

                    </Fragment>
                );
            case 4:
                return (
                    <Fragment>
                        <TablePaginatedSearchVoucher
                            title=""
                            columns={columns}
                            numeroFilas={5}
                            requestConfig={requestConfigSeacrh}
                            BotonesHeader={headerBottons}
                            paramSearch={paramSearch}
                            seleccion={true}
                            setIdVoucher={setIdVoucher}
                        />

                    </Fragment>
                )
            default:
                break;
        }
    }

    return (
        <div className={classesView.root}>
            <Backdrop open={openLoader} className={classesView.backdrop}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <SearchVoucher
                update={update}
                setUpdate={setUpdate}
                setParamSearch={setParamSearch}
            />

            {/* <Card className={classesView.margin} >
                <Grid container className={classesView.zip} direction="row" alignItems="center" onClick={generateZip} >
                    <Grid item xs={6} >
                        <label className={classesGlobales.titleCard}>
                            Para descargar varios comprobantes a la vez, seleccione y dé clic en este botón:
                        </label>
                    </Grid>
                    <Grid container item xs={6} direction="row-reverse" justify="flex-start" alignItems="center">
                        <Avatar variant="square" src="../zip.png" className={classesView.small} />
                    </Grid>
                </Grid>
            </Card> */}

            {renderTable()}
        </div>
    );
}
export default VoucherReceivedAts;